import OrdemServicoSubItemService from "@/services/OrdemServicoSubItemService";

export const ordemServicoSubItem = {
  namespaced: true,
  state: {
    ordemServicoSubItem: {},
  },
  actions: {
    getOrdemServicoSubItem({ commit }, payload) {
      return OrdemServicoSubItemService.GetOrdemServicoSubItem(payload).then(
        (ordemServicoSubItem) => {
          return Promise.resolve(ordemServicoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoSubItem({ commit }, payload) {
      return OrdemServicoSubItemService.PostOrdemServicoSubItem(payload).then(
        (ordemServicoSubItem) => {
          return Promise.resolve(ordemServicoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoSubItem({ commit }, payload) {
      return OrdemServicoSubItemService.PutOrdemServicoSubItem(payload).then(
        (ordemServicoSubItem) => {
          return Promise.resolve(ordemServicoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoSubItem({ commit }, payload) {
      return OrdemServicoSubItemService.DeleteOrdemServicoSubItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoSubItemOData({ commit }, payload) {
      return OrdemServicoSubItemService.GetOrdemServicoSubItemOData(
        payload
      ).then(
        (ordemServicoSubItem) => {
          return Promise.resolve(ordemServicoSubItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoSubItem;
